import { segmentTrackAction } from 'lib/segment'
import { EVENT } from 'lib/segment/const'

export const segmentFindItemStoreListViewed = ({
  id_product,
  id_product_attribute,
  id_customer,
  store_ids,
}) => {
  const data = {
    id_product,
    id_product_attribute,
    id_customer,
    store_ids,
  }
  segmentTrackAction(EVENT.findItemStoreListViewed, data)
}

export const segmentFindItemStoreSelected = ({
  id_product,
  id_product_attribute,
  id_customer,
  store_id,
}) => {
  const data = {
    id_product,
    id_product_attribute,
    id_customer,
    store_id,
  }
  segmentTrackAction(EVENT.findItemStoreSelected, data)
}
